export default __webpack_public_path__ + "f67bd49c490d7e718a98688bda94c32c.svg";